<template>
    <Dialog modal v-model:visible="isVisible" :style="{width: (title == 'Account' || title == 'Company') ? '90vw' : '80vw'}" :closable="false" :draggable="false">
        <template #header>
			<div class="row">
				<div class="col-md-12 d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">
					<span class="fs-5">Import Preview
						<div class="p-3">
                            <Badge class="mr-2" severity="info" :value="'Total: ' + (validCount + errorCount + warningCount)"></Badge>
                            <Badge class="mr-2" severity="success" :value="'Valid: ' + validCount"></Badge>
                            <Badge class="mr-2" severity="warning" :value="'Warning: ' + warningCount"></Badge>
                            <Badge class="mr-2" severity="danger" :value="'Error: ' + errorCount"></Badge>
						</div>
					</span>
				</div>
			</div>
        </template>

        <div class="row">
            <DataTable class="p-datatable-sm" stripedRows :value="invalidRows" :paginator="true" :rows="5">
                <Column :style="{width: 8 - (itemHeaders.length - 2) + '%'}" header="Row #" field="rowNum"></Column>
                <Column v-for="(item, item_index) in itemHeaders" :key="item_index" style="word-wrap: break-word;" 
                    :style="'width: ' + item.width + ';'" 
                    :header="item.value" :field="'items.' + item.value">
                </Column>
                <Column :style="{width: 10 - (itemHeaders.length - 2) + '%'}" header="Type" field="type">
                    <template #body="slotProps">
                        <span class="badge rounded-pill d-inline" :class="[slotProps.data.type == 'Error' ? 'bg-danger' : 'bg-warning']">{{slotProps.data.type}}</span>
                    </template>
                </Column>
                <Column :style="{width: 30 - (itemHeaders.length) + '%'}" header="Remarks" field="remarks"></Column>

                <template #empty>
                    <div class="error-no-record">
                        <FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
                        <h6><span>No Warning and Error Found</span></h6>
                    </div>
                </template>
            </DataTable>
        </div>

        <template #footer>
            <div class="col-md-12">
                <div class="align-items-center my-2" style="color: red;">Please download the error list to review the issues.</div>
                <div class="col-md-12 d-flex justify-content-end">
                    <TheLoading v-if="isImportLoading"></TheLoading>
                    <Button class="p-button-text p-button-sm" label="Download" icon="pi pi-download" @click="downloadImportError()" :disabled="errorCount == 0 && warningCount == 0" />
                    <Button class="p-button-text p-button-sm" label="Cancel" icon="pi pi-times" @click="closeDialog" />
                    <Button class="p-button-sm" label="Proceed" :disabled="validCount == 0 && warningCount == 0 || isImportLoading" @click="proceedImport(true)"/>
                    <!-- <SplitButton class="p-button-sm" icon="pi pi-check" label="Proceed" :model="proceedItems" id="splitButton" :disabled="validCount == 0 && warningCount == 0 || isImportLoading" @click="splitButton"></SplitButton> -->
                </div>
            </div>
        </template>
    </Dialog>
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import errorUtilMixin from "@/mixin/utils/error-utils";
    import excelUtilMixin from "@/mixin/utils/excel-utils";

    import TheLoading from "@/components/TheLoading.vue";

    export default defineComponent({
        mixins: [errorUtilMixin, excelUtilMixin],
        components: {
			TheLoading,
		},
        data() {
            return {
                isVisible: false,
                isImportLoading: false,
                invalidRows: [] as any[],
                itemHeaders: [] as any[],
                validCount: 0,
                warningCount: 0,
                errorCount: 0
            }
        },
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        watch: {
            visible(newValue: any) {
                if (newValue != null) {
                    this.isVisible = newValue;
                    if (this.isVisible) {
                        document.body.classList.add("dialog-open");
                        this.isImportLoading = false;
                    }

                    else {
                        document.body.classList.remove("dialog-open");
                        this.isImportLoading = false;
                    }
                }
            },
            data(newValue: any) {
                if (newValue != null) {
                    this.invalidRows = newValue.invalidRows;
                    this.validCount = newValue.validCount;
                    this.warningCount = newValue.warningCount;
                    this.errorCount = newValue.errorCount;
                    
                    this.itemHeaders = [];
                    if (this.invalidRows.length > 0 && Object.keys(this.invalidRows[0]).includes('items')) {
                        var headers = Object.keys(this.invalidRows[0].items);
                        headers.forEach((header: any, index: any) => {
							var item = {value: header, width: '10%'};
							if (this.title == 'Country') {
								if (header == 'Code') {
									item.width = '15%';
								}
									
								else if (header == 'Name') {
									item.width = '37%';
								}
							}
							
							else if (this.title == 'Currency' || this.title == 'Purpose') {
								if (header == 'Code') {
									item.width = '12%';
								}
									
								else if (header == 'Name') {
									item.width = '28%';
								}
								
								else if (header == 'Exchange Rate' || header == 'Suffix') {
									item.width = '12%';
								}
							}
							
							else if (this.title == 'Account') {
								if (header == 'Code') {
									item.width = '5%';
								}
									
								else if (header == 'Account Type') {
									item.width = '12%';
								}
								
								else if (header == 'Name') {
									item.width = '15%';
								}
								
								else if (header == 'Description') {
									item.width = '20%';
								}
							}
							
							else if (this.title == 'Company') {
								if (header == 'Code') {
									item.width = '9%';
								}
									
								else if (header == 'Name') {
									item.width = '27%';
								}
								
								else if (header == 'Legal Parent') {
									item.width = '16%';
								}
							}
							
							else if (this.title == 'Sheet') {
								if (header == 'Code') {
									item.width = '5%';
								}
									
								else if (header == 'Name') {
									item.width = '35%';
								}
								
								else if (header == 'Type') {
									item.width = '6%';
								}
								
								else if (header == 'Sequence') {
									item.width = '6%';
								}
							}
									
							this.itemHeaders.push(item);
						});
                    }
                }
            }
        },
        computed: {
            proceedItems() {
                return [
					{
						label: 'With Override (' + this.warningCount + ')',
                        disabled: this.warningCount == 0,
						command: () => {
							this.proceedImport(true);
						},
					},
					{
						label: 'Without Override (' + this.validCount + ')',
                        disabled: this.validCount == 0,
						command: () => {
							this.proceedImport(false);
						}
					},
				]
            }
        },
        methods: {
            closeDialog() {
                this.$emit('close-dialog-event');
            },
            downloadImportError() {
                this.downloadExcelFileWithJson(this.convertToExcel(this.invalidRows),  "_Error_" + this.title + ".xlsx");
            },
            proceedImport(isOverride: boolean) {
                this.isImportLoading = true;
                this.$emit('proceed-import-event', isOverride);
            },
            splitButton() {
                var splitButton = document.getElementById('splitButton')?.getElementsByClassName('p-splitbutton-menubutton')[0] as HTMLElement;
				splitButton.click();
            }
        }
    });
</script>